import ActionTick from './ActionTick';

export default ActionTick;
